module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-swipe-fullpage",
    class: [_vm.transition ? 'fullpage-item-transition' : '']
  }, _vm._l((_vm.viewModel), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "fullpage-item",
      class: [_vm.active == index ? 'active' : '']
    }, [_c('c-page', {
      staticStyle: {
        "background-color": "transparent"
      }
    }, [_c('c-content', [_c('template', {
      slot: "noscroll"
    }, [_c('div', {
      staticClass: "card"
    }, [_c('img', {
      staticClass: "img-cover",
      attrs: {
        "src": item.imgCover
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('ul', _vm._l((item.descs), function(desc) {
      return _c('li', {
        key: desc
      }, [_vm._v("\n                  " + _vm._s(desc.content) + "\n                ")])
    }))]), _vm._v(" "), (item.descBtn) ? _c('div', {
      staticClass: "footer",
      on: {
        "click": function($event) {
          _vm.stdBtn(item.descBtn.func)
        }
      }
    }, [_vm._v("\n              " + _vm._s(item.descBtn.title) + "\n            ")]) : _vm._e()]), _vm._v(" "), (item.btn) ? _c('c-button', {
      class: item.btn.class,
      attrs: {
        "btn-type": item.btn.type
      },
      nativeOn: {
        "click": function($event) {
          _vm.stdBtn(item.btn.func)
        }
      }
    }, [_vm._v("\n            " + _vm._s(item.btn.title) + "\n          ")]) : _vm._e()], 1)], 2)], 1)], 1)
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d26fb3fc","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/c-swipe-fullpage/index.vue
// module id = 1072
// module chunks = 2